export default {
  canBeRedirected: false,
  isRedirected: false,
};
